export const getAcceptedTypes = <T extends string>(types: T[]) => {
	const normalizeTypes = types.map(type =>
		type.replace('image/', '').toUpperCase(),
	);

	return normalizeTypes.join(', ');
};

export const getAcceptedVideoTypes = (types: string[]) => {
	const normalizeTypes = types.map(type => type.replace('.', '').toUpperCase());

	return normalizeTypes.join(', ');
};
